export const IMAGE_URL_EXPIRATION = 600;  // seconds
